import { Grid, Typography, TextField, useTheme } from '@mui/material'
import { fieldStyles } from '../style'
import { BoxScroller } from 'styles/elements/styleElements'
import { useLayoutContext } from 'context/LayoutProvider/LayoutProvider'

const IntegrationFields = ({ deal, organization, formData, onInputChange, expanded, isDisabled = false }) => {
  const { pinned } = useLayoutContext()
  const expanded_height = expanded ? 'calc(100vh - 210px)' : 'calc(100vh - 80px)'
  const pinned_height = `calc(${expanded_height} - 50px)`
  const calc_height = pinned ? pinned_height : expanded_height
  const theme = useTheme()
  return (
    <BoxScroller sx={{ height: calc_height, maxHeight: '100vh', transition: 'height 0.3s ease', overflowY: 'auto' }}>
      <Grid item xs={12}>
        <Typography variant="subtitle1">Account Fields</Typography>

        {(deal?.isGoogleSearch || deal?.isGoogleDisplay) && (
          <TextField
            label="Google Ads Account Id"
            value={formData?.googleAdsId ?? ''}
            onChange={e => onInputChange('googleAdsId', e.target.value)}
            fullWidth
            margin="dense"
            sx={{ ...fieldStyles(theme.palette.background.default) }}
            disabled={isDisabled}
          />
        )}

        {deal?.isMetaAdvertising && (
          <>
            <TextField
              label="Meta Account Id"
              value={formData?.metaAccountId ?? ''}
              onChange={e => onInputChange('metaAccountId', e.target.value)}
              fullWidth
              margin="dense"
              sx={{ ...fieldStyles(theme.palette.background.default) }}
              disabled={isDisabled}
            />
            <TextField
              label="Meta Pixel Id"
              value={formData?.metaPixelId ?? ''}
              onChange={e => onInputChange('metaPixelId', e.target.value)}
              fullWidth
              margin="dense"
              sx={{ ...fieldStyles(theme.palette.background.default) }}
              disabled={isDisabled}
            />
          </>
        )}

        {deal?.isTikTok && (
          <>
            <TextField
              label="TikTok Account Id"
              value={formData?.tiktokAccountId ?? ''}
              onChange={e => onInputChange('tiktokAccountId', e.target.value)}
              fullWidth
              margin="dense"
              sx={{ ...fieldStyles(theme.palette.background.default) }}
              disabled={isDisabled}
            />
            <TextField
              label="TikTok Pixel Id"
              value={formData?.tiktokPixelId ?? ''}
              onChange={e => onInputChange('tiktokPixelId', e.target.value)}
              fullWidth
              margin="dense"
              sx={{ ...fieldStyles(theme.palette.background.default) }}
              disabled={isDisabled}
            />
          </>
        )}

        {deal?.isSimplifi && (
          <TextField
            label="Simplifi Organization Id"
            value={formData?.simplifiOrgId ?? ''}
            onChange={e => onInputChange('simplifiOrgId', e.target.value)}
            fullWidth
            margin="dense"
            sx={{ ...fieldStyles(theme.palette.background.default) }}
            disabled={isDisabled}
          />
        )}

        {deal?.isMicrosoftAdvertising && (
          <>
            <TextField
              label="Bing Account Id"
              value={formData?.bingAccountId ?? ''}
              onChange={e => onInputChange('bingAccountId', e.target.value)}
              fullWidth
              margin="dense"
              sx={{ ...fieldStyles(theme.palette.background.default) }}
              disabled={isDisabled}
            />
            <TextField
              label="Bing UET Id"
              value={formData?.bingUetId ?? ''}
              onChange={e => onInputChange('bingUetId', e.target.value)}
              fullWidth
              margin="dense"
              sx={{ ...fieldStyles(theme.palette.background.default) }}
              disabled={isDisabled}
            />
          </>
        )}

        {deal?.isWebsiteBuild && (
          <>
            <TextField
              label="Website Template URL"
              value={formData?.websiteTemplateUrl ?? ''}
              onChange={e => onInputChange('websiteTemplateUrl', e.target.value)}
              fullWidth
              margin="dense"
              sx={{ ...fieldStyles(theme.palette.background.default) }}
              disabled={isDisabled}
            />
            {deal?.isAddPage && (
              <>
                <TextField
                  label="Number of Website Pages"
                  type="number"
                  value={formData?.websitePages ?? ''}
                  onChange={e => onInputChange('websitePages', e.target.value)}
                  fullWidth
                  margin="dense"
                  sx={{ ...fieldStyles(theme.palette.background.default) }}
                  disabled={isDisabled}
                />
                <TextField
                  label="Additional Website Notes"
                  value={formData?.websiteNotes ?? ''}
                  onChange={e => onInputChange('websiteNotes', e.target.value)}
                  fullWidth
                  margin="dense"
                  multiline
                  rows={3}
                  sx={{ ...fieldStyles(theme.palette.background.default) }}
                  disabled={isDisabled}
                />
              </>
            )}
          </>
        )}
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle1">Addt'l Notes Section</Typography>
        <TextField
          label="Website Notes"
          value={formData?.websiteNotes ?? ''}
          onChange={e => onInputChange('websiteNotes', e.target.value)}
          fullWidth
          multiline
          rows={3}
          margin="dense"
          sx={{ ...fieldStyles(theme.palette.background.default) }}
          disabled={isDisabled}
        />
        <TextField
          label="Tracked Conversions"
          value={formData?.trackedConversions ?? ''}
          onChange={e => onInputChange('trackedConversions', e.target.value)}
          fullWidth
          multiline
          rows={3}
          margin="dense"
          sx={{ ...fieldStyles(theme.palette.background.default) }}
          disabled={isDisabled}
        />
      </Grid>
    </BoxScroller>
  )
}

export default IntegrationFields
